import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import styles from './evidences.module.scss';

const ProcessingModal = ({ previewChecked, selectedCountry, errorMessage }: { previewChecked: boolean; selectedCountry: { label: string; flagUrl: string }; errorMessage: string }) => {
  const { t } = useTranslation();

  const getPreviewMessage = () => <>
    <div className={styles['country-transfer-animation']}>
      <div className={`${styles['country-flag']} source-country`}>
        <img src="https://flagcdn.com/w80/ie.png" alt="Ireland" style={{ width: "80px" }} />
        <div className={styles['country-label']}>{t("country.ireland")}</div>
      </div>

      <div className={styles['transfer-path']}>
        <div className={styles['document-traveling']}>
          <div className={styles['document-icon']}>📄</div>
          <div className={styles['travel-dots']}>
            <span className={styles['dot']}></span>
            <span className={styles['dot']}></span>
            <span className={styles['dot']}></span>
          </div>
        </div>
        <div className={styles['transfer-arrow']}>➡️</div>
      </div>

      <div className={`${styles['country-flag']} destination-country`}>
        <img src={selectedCountry.flagUrl} alt={selectedCountry.label} style={{ width: "80px" }} />
        <div className={styles['country-label']}>{selectedCountry.label}</div>
      </div>
    </div>
    <p style={{ marginTop: "1rem", fontWeight: "500", fontSize: "1.25rem" }}>
      {t('preview.loading.redirectingRequesterPortal')}
    </p>
  </>;

  const getProcessingMessage = () => <>
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <img src={selectedCountry.flagUrl} alt={selectedCountry.label} style={{ width: "80px" }} />
    </div>
    <div className="spinner" />
    <p style={{ marginTop: "1rem", fontWeight: "500", fontSize: "1.25rem" }}>
      {t('evidences.gettingRequestedEvidence', { country: selectedCountry.label })}
      <br />
      {t('evidences.thisCanTake')}
    </p>
  </>;

  return <div className="overlay">
    <div className="popup" id="BOX_PROCESSING_MODAL">
      <div className="header">{t('preview.table.evidence')}</div>
      <div className="info" style={{ textAlign: "center" }}>
        {previewChecked
          ? getPreviewMessage()
          : getProcessingMessage()}
      </div>
    </div>
  </div>
}

ProcessingModal.propTypes = {
  previewChecked: PropTypes.bool,
  selectedCountry: PropTypes.shape({
    label: PropTypes.string.isRequired,
    flagUrl: PropTypes.string.isRequired,
  }),
  errorMessage: PropTypes.string,
};

export default ProcessingModal;
